import { useFirebaseLogin } from "@/app/hooks/api_hooks/auth/useFirebaseLogin";
import { useUserAuthenticationTokenAPI } from "@/app/hooks/api_hooks/auth/useUserAuthenticationTokenAPI";
import { useRouter } from "@/app/hooks/useRouter";
import React, { useEffect } from "react";
import { FcGoogle } from "react-icons/fc/index";
import { useNavigate } from "react-router";
import { IGoogleSigninButtonProps } from "./interface";

const GoogleSigninButton: React.FC<IGoogleSigninButtonProps> = (_props) => {
  const { signInWithGoogle, accessToken } = useFirebaseLogin();
  const { getRouteKey } = useRouter();
  const { callback: IAMAuthorizationAPI, logStatus } = useUserAuthenticationTokenAPI();

  const navigate = useNavigate();

  useEffect(() => {
    if (accessToken) {
      IAMAuthorizationAPI(accessToken);
    }
  }, [accessToken]);

  useEffect(() => {
    if (logStatus === true) {
      navigate(getRouteKey("VMS_SETUP", "url"));
    }
  }, [logStatus]);

  return (
    <button
      onClick={() => {
        signInWithGoogle();
      }}
      type="button"
      className="flex w-full sm:w-auto bg-black border-transparent justify-center sm:justify-start items-center rounded-md px-3.5 py-2.5 text-sm font-semibold text-gray-900"
    >
      <FcGoogle />
      <span className="ml-2 text-white">Signin With Google</span>
    </button>
  );
};

export default GoogleSigninButton;
